<template>
  <v-dialog
    v-model="dialog"
    no-click-animation
    overlay-color="rgba(39, 50, 64)"
    overlay-opacity="0.6"
    :fullscreen="$vuetify.breakpoint.xs ? true : false"
    persistent
    width="500"
    :transition="false"
  >
    <v-card>
      <v-card-title>
        {{ $t('accounts.accSuspended') }}
      </v-card-title>
      <v-card-text>
        {{ $t('accounts.accSuspendedDesc') }}
      </v-card-text>
      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          outlined
          text
          @click="go()"
        >
          {{ $t('invoices.viewInvoices') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: 'HelperSuspended',
  data: () => ({
  }),
  computed: {
    ...mapGetters("user", ["getUserSettings"]),
    dialog: {
      get() {
        if (!this.getUserSettings) {
          return false
        }
        if (this.getUserSettings.overdue_wl_usage_invoices > 0 
            && this.$route.name != 'My Invoices' 
            && this.$route.name != 'View  My Invoice' 
            && this.$route.name != 'ThankYou') {
          return true
        }
        return false
      },
      set(val) {

      }
    }
  },
  methods: {
    go() {
      this.dialog = false
      this.$router.push('/myinvoices')
    }
  }

}
</script>

<style lang="scss" scoped>
</style>
